import _axios from '../../apiClient'


export function getRubros(query, activos, comboBox) {

  return _axios.get(`/api/Rubro/Get`,
    {
      params:{rubro: query, activos, comboBox},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getRubro(id) {

  return _axios.get(`/api/Rubro/GetRubro`,
    {
      params:{id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function swapRubros( from, to) {

  return _axios.get(`/api/Rubro/swapRubro`,
    {
      params: {from , to},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)

      
    })
}


export function swapSubRubros( from, to) {

  return _axios.get(`/api/Rubro/swapSubRubro`,
    {
      params: {from , to},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)

      
    })
}
export function getSubrubros(payload, query,comboBox) {
  
  return _axios.get(`/api/Rubro/getsubrubros`,
  { 
    params: { idRubro: payload, subrubro: query, comboBox: comboBox } 
},
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)

      
    })
}

export function getSubrubrosPicking() {
  return _axios.get(`/api/Rubro/GetSubrubrosPicking`,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function swapSubRubrosPicking( from, to) {
  return _axios.get(`/api/Rubro/SwapSubRubroPicking`,
    {
      params: {from , to},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getSuperRubros() {
  
  return _axios.get(`/api/Rubro/getSuperRubros`,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)

    })
}

export function saveImagen(payload) { 
  let newFile = payload.currentFile;
  let formData = new FormData();
  formData.append('file', newFile);
  return _axios.post(`/api/Rubro/SubirImagen`,
  formData,
  {
    params:{
      idTemporal: payload.idTemporal,
      original: payload.original,
      subrubro: payload.subrubro?payload.subrubro:false
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data
    throw (data)
  })
}


export function saveRubro(payload) {

  return _axios.post(`/api/Rubro/SaveRubro`,
    payload,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}



export function getSubRubro(id) {

  return _axios.get(`/api/Rubro/GetSubRubro`,
    {
      params:{id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}


export function eliminarSubRubro(id) {

  return _axios.get(`/api/Rubro/Eliminar`,
    {
      params:{idSubrubro: id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function eliminiarRubro(id) {

  return _axios.get(`/api/Rubro/Eliminar`,
    {
      params:{idRubro: id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function revertirSubRubro(id) {

  return _axios.get(`/api/Rubro/Revertir`,
    {
      params:{idSubrubro: id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function revertirRubro(id) {

  return _axios.get(`/api/Rubro/Revertir`,
    {
      params:{idRubro: id},
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
export function saveSubRubro(payload) {

  return _axios.post(`/api/Rubro/SaveSubRubro`,
    payload,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
